
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import {
  chipColor, chipOutlined, tooltipColor, tooltipText,
} from '@/helpers';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationEnd extends Mixins(OperationComponentMixin) {
  get docsSentToPartner(): boolean {
    return this.operationChild?.docsSentToPartner === true;
  }

  get docsSentToCustomer(): boolean {
    return this.operationChild?.docsSentToCustomer === true;
  }

  get columnClass(): string {
    if (this.operationChild?.flatTasks.includes('R=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('R=e')) return 'error';
    return '';
  }

  get titoloAutorizzativoIsNotAvailable(): boolean {
    return this.operation?.titoloAutorizzativo === 'na';
  }

  get hasEndOfWorkNotes(): boolean {
    return this.operation?.hasEndOfWorkNotes === true;
  }

  get endOfWorkChipColor(): string {
    if (this.titoloAutorizzativoIsNotAvailable) return 'grey';

    return this.operation ? chipColor(this.operation?.endOfWork) : '';
  }

  get endOfWorkChipOutlined(): boolean {
    if (this.titoloAutorizzativoIsNotAvailable) return true;

    return this.operation ? chipOutlined(this.operation?.endOfWork) : false;
  }

  get endOfWorkTooltipColor(): string {
    if (this.titoloAutorizzativoIsNotAvailable) return 'grey';

    return this.operation ? tooltipColor(this.operation?.endOfWork) : '';
  }

  get endOfWorkTooltipText(): string {
    if (this.titoloAutorizzativoIsNotAvailable) return 'Titolo autorizzativo non applicabile';

    return this.operation ? tooltipText('Fine lavori', this.operation?.endOfWork) : 'Fine lavori';
  }

  onEdit(section: string) {
    console.log(`OperationEnd: onEdit('${section}')`); // eslint-disable-line no-console
    this.$emit('edit', section);
  }
}
